module.exports = __webpack_public_path__ + "static/media/suitcase-rolling.cdab734b.svg";